import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ConfirmDialogComponent } from './confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {

  constructor(private dialog: MatDialog) { }

  public confirm(title: string, message: string, buttonLabel: string): Observable<boolean> {
    let dialogRef: MatDialogRef<ConfirmDialogComponent>;

    dialogRef = this.dialog.open(ConfirmDialogComponent,
      {
        panelClass: 'db-dialog',
        width: '700px'
      }
    );

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.buttonLabel = buttonLabel;

    return dialogRef.afterClosed();
  }
}
